import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Doctor from './pages/Doctor';
import DoctorPatients from './pages/DoctorPatients';
import Patient from './pages/Patient';
import TokenHandler from './components/TokenHandler';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path={"/doctor"} element={<Doctor />} />
          <Route path={"/patient"} element={<Patient />} />
          <Route path={"*"} element={<Navigate to={'/patient'} />} />
          <Route path={"/doctor-patients"} element={<DoctorPatients />} />
        </Routes>
        <TokenHandler/>
      </BrowserRouter>
  );
}

export default App;
